import React from "react";
import { Check, Star } from "lucide-react";
import { PRICING, waLink } from "../mock";

export default function Pricing() {
  const buyMsg = "Hi, I'm interested in purchasing the THE REAL ALGO EA";
  return (
    <section id="pricing" className="py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center reveal">
          <span className="text-[12px] tracking-[0.25em] text-[#2e9bff] font-semibold">PRICING PACKAGE</span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-white mt-4">Get Started with <span className="text-blue-grad">Limited Time Promotion</span></h2>
          <p className="text-slate-400 mt-4 max-w-2xl mx-auto">Choose the perfect plan for your trading journey. All plans include full access and premium features.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5 mt-14 items-stretch">
          {PRICING.map((p) => (
            <div key={p.name} className={`reveal relative rounded-2xl p-6 flex flex-col transition-all duration-300 hover:-translate-y-1.5 ${p.popular ? "blue-glow" : ""}`}
              style={{ background: p.popular ? "linear-gradient(160deg,#0e2036,#0a1424)" : "rgba(13,21,38,0.6)", border: p.popular ? "1.5px solid rgba(46,155,255,0.6)" : "1px solid rgba(46,155,255,0.14)" }}>
              {p.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 text-[11px] font-bold px-3 py-1 rounded-full btn-primary">
                  <Star className="w-3 h-3 fill-white" /> Most Popular
                </span>
              )}
              {p.off && <span className="absolute top-4 right-4 text-[10.5px] font-bold px-2 py-0.5 rounded bg-[#22e39a]/15 text-[#22e39a]">{p.off}</span>}
              <h3 className="text-white font-semibold text-lg">{p.name}</h3>
              <p className="text-slate-400 text-xs mt-1 min-h-[32px]">{p.desc}</p>
              <div className="mt-4 flex items-end gap-2">
                <span className="font-display text-4xl font-bold text-white">{p.price}</span>
                {p.old && <span className="text-slate-500 line-through text-sm mb-1">{p.old}</span>}
              </div>
              <p className="text-slate-500 text-xs mt-1">{p.note}</p>
              <ul className="mt-5 space-y-2.5 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-slate-300"><Check className="w-4 h-4 text-[#2e9bff] shrink-0 mt-0.5" /> {f}</li>
                ))}
              </ul>
              <a href={waLink(buyMsg)} target="_blank" rel="noreferrer" className={`mt-6 text-center py-3 rounded-full font-semibold text-sm ${p.popular ? "btn-primary" : "btn-ghost"}`}>
                {p.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
